<div class="item-container d-flex flex-column h-100">
    <div class="item-header ">
        <h6 class="text-center mb-0">{{objectType}} Object</h6>
        <div class="edit-icons cursor-pointer" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <form [formGroup]="addObjectForm" class="item-content flex-grow-1 d-flex flex-column h-100">
    <div class=" flex-grow-1">      
            <div class="row h-100">               
                <div class="col-md-6 col-lg-7 l-block">
                    <div class="pt-2 pt-lg-4  me-lg-2 pe-lg-3">
                        <label for="">{{objectType}} title</label>
                        <input type="text" class="form-control" formControlName="sub_tit">
                        <mat-error *ngIf="isControlHasError('sub_tit','required')">{{"Title is required" |translate}}  </mat-error>
                        <div>
                            <label for="" class="mt-2 mt-lg-4">{{objectType}} content</label>
                        </div>
                        <div class="" *ngIf="selectedItem.input_t=='link'">
                            <input type="text" class="form-control" placeholder="Paste your link here" formControlName="subs_cont" (change)="onLinkChange()">
                            <mat-error *ngIf="isInvalidYoutubeURL">Please enter valid youtube url.</mat-error>
                        </div>
                        <div class="" *ngIf="selectedItem.input_t=='textarea'">
                            <quill-editor [styles]="{width: '100%'}" class="d-block" formControlName="subs_cont"></quill-editor>
                        </div>
                        <div class="drop-box m-auto" *ngIf="(selectedItem.input_t=='file' || selectedItem.input_t=='image') && !serverFileName ">
                            <ngx-dropzone class="drop-item" (change)="onSelect($event)" class="drop-item" [multiple]="false"  [accept]="getAcceptType()" >
                                <ngx-dropzone-label>
                                    <div class="d-box">
                                        <div class="me">
                                            <img src="assets/images/apps/upload_file.svg" class="img-fluid" alt="">
                                        </div>
                                        <div>
                                            <div class="text-left">Click to Upload</div>
                                            <div class="upload-text text-left">Or just drag and drop</div>
                                        </div>
                                    </div>
                                    <div class="note-txt pt-2">Note: File Size cannot be greater than 200MB.</div>
                                </ngx-dropzone-label>
                                <ngx-dropzone-preview *ngFor="let f of files"  (removed)="onRemove(f)"  >
                                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                                </ngx-dropzone-preview>
                            </ngx-dropzone>
                            <div class="custom-loader" *ngIf="isSpinnerLoading"></div>
                        </div>
                        <div class="uploaded-container "*ngIf="(selectedItem.input_t=='file' || selectedItem.input_t=='image') && serverFileName" >
                            <i class="material-icons close-icon" (click)="onDeleteFile()">close</i>
                            <div class="uploaded-box d-flex align-items-center justify-content-center">
                                <div class="upload-img">
                                    <img src="assets/images/object_icons/upload_file.png" class="img-fluid">
                                </div>
                                <div class="ps-2 d-flex flex-column justify-content-center upload-content">
                                    <div class="uploaded-txt">{{getFileName(serverFileName)}}</div>
                                    <div class="mt-1">Uploaded Successfully</div>
                                </div>
                            </div>
                        </div>
                       
                        <mat-error *ngIf="isFileSizeError">{{"Max file size supported is 200MB" |translate}}  </mat-error>
                        <mat-error *ngIf="isControlHasError('subs_cont','required')">{{"Content is required" |translate}}  </mat-error>
                        <div>
                            <label for="" class="mt-4">{{objectType}} settings</label>
                        </div>
                        <div class="d-flex" *ngFor="let item of selectedItem.sett">
                            <mat-checkbox name="agree"  [checked]="item.key_value==true " (change)="onCheckBoxValue(item,$event)">
                                <div class="text-wrap set-txt"> {{item.title}}</div>
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-5 d-flex r-block mob-bg" >
                    <div class="mobile-container  m-auto" [style.background-image]="'url('+selectedTheme+')'"
                     [ngClass]="{'video-cont': (selectedItem.type=='youtube' || selectedItem.type=='video'),
                                 'theme-cont': selectedTheme!=''}">
                        <div class="mob-header pt-3 pb-1">
                            <span class="sentence-wrapper mx-2">{{ addObjectForm.get('sub_tit')?.value }}</span>
                            <div class="mobile-curve"><img src="assets/images/apps/mobile_header_curve.png"  alt=""></div>
                        </div>
                        <div class="mobile-content d-flex flex-column" [ngClass]="{'d-box': (selectedItem.type=='file' || selectedItem.type=='audio' ||
                         selectedItem.type=='link' || selectedItem.type=='youtube'|| selectedItem.type=='video'||selectedItem.type=='image'||selectedItem.type=='iframe') }">
                            <div class="m-con-box flex-grow-1" [ngClass]="{'d-block':selectedItem.type=='text'}">
                                                               
                                 <div class="ql-snow" *ngIf="selectedItem.type=='text'">
                                    <div class="ql-editor small-text " *ngIf="addObjectForm.get('subs_cont')?.value" [innerHtml]="addObjectForm.get('subs_cont')?.value |  sanitizeHtml"></div>
                                  </div>
                             
                                  <div class="m-sub-con"  *ngIf="selectedItem.type=='file' && (addObjectForm.get('subs_cont')?.value)">
                                    <div class="file-box d-flex align-items-center justify-content-center" >
                                        <img src="assets/images/object_icons/mobile_obj_preview.png" alt="">
                                      </div>
                                      <div class="mt-4 text-center"> 
                                        <button mat-raised-button color="warn" class="btn  primary-btn " type="submit"> {{"Download"|translate}}</button>
                                      </div>
                                  </div>
                                  <div class="m-sub-con d-box"  *ngIf="selectedItem.type=='image' && (addObjectForm.get('subs_cont')?.value)">
                                    <div  >
                                        <img [src]="serverFileName" class="img-fluid" alt="">
                                      </div>
                                     
                                  </div>
                                  <div class="m-sub-con" *ngIf="selectedItem.type=='audio' && safeUrl">
                                     <div class="file-box d-flex align-items-center justify-content-center m-auto">
                                        <img src="assets/images/object_icons/audio.png" alt="">
                                      </div>
                                      <div class="mt-4 text-center"> 
                                        <audio controls *ngIf="safeUrl" width="200px" style="width:220px">
                                            <source [src]="safeUrl" type="audio/mp3">                                           
                                          </audio>
                                      </div>
                                  </div>
                        
                                  <div class="m-a-box"  *ngIf="selectedItem.type=='link' && addObjectForm.get('subs_cont')?.value">
                                    <div class="file-box d-flex align-items-center justify-content-center m-auto">
                                        <img src="assets/images/object_icons/mobile_obj_preview.png" alt="" class="img-fluid">
                                      </div>
                                       <p class="mt-3 text-center">Note: This link preview is available only on mobile. Please click the button below to open the link in a new tab</p>
                                       <div class="text-center"> 
                                        <button mat-raised-button color="warn" class="btn  primary-btn " type="submit" (click)="openLink()"> {{"Open Link"|translate}}</button>
                                      </div>
                                  </div>
                                  <div class="m-sub-con" *ngIf="selectedItem.type =='youtube'">
                                    <iframe *ngIf="safeSrc" [src]="safeSrc" width="230" height="240" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                                    
                                  </div>
                                  <div class="m-sub-con" *ngIf="selectedItem.type =='iframe'">
                                    <iframe  [src]="addObjectForm.get('subs_cont')?.value | safe :'resourceUrl'" width="230" height="240" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                                    
                                  </div>
                                  <div class="m-sub-con" *ngIf="selectedItem.type=='video'">
                                    <video width="230" *ngIf="safeUrl" controls>
                                    <source [src]="safeUrl" type="video/mp4">                         
                                  </video>
                                 </div>   
                                 <div class="m-sub-con " *ngIf="selectedItem.type=='pdf'">
                                    <div style="width: 248px; height: 405px" class="text-center">
                                    
                                        <pdf-viewer [src]="serverFileName" *ngIf="serverFileName"
                                        [render-text]="true"
                                        [original-size]="false"
                                        style="width: 100%; height: 100%" ></pdf-viewer>
                                    </div>
                                   
                                 </div>   
                                  
                        
                                                                  
                            </div>    
                            <div class="text-center" *ngIf="isUnderstandBtn">
                                <button mat-raised-button color="primary" class="auth-form-btn manage-btn primary-btn mb-2" >  {{"I understand"|translate}}
                                  </button>
                            </div>               
                        </div>   
                    </div>
                </div>          
            </div>
    </div>
</form>     
    <div class="item-footer">
        <div class="d-flex justify-content-end align-items-center ">
            <button type="button" (click)="onCancel()"
                class="auth-form-btn outline-btn new-outline d-flex align-items-center justify-content-center mt-3 me-3 mb-sm-2 mb-xxl-0">{{"Cancel" |translate}}</button>
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mb-sm-2 mb-xxl-0" (click)="onSaveCourse()" [disabled]="addObjectForm.invalid"
                type="submit">{{"Save"|translate}}</button>
        </div>
    </div>
</div>

<app-loading-spinner></app-loading-spinner>